import Vue from 'vue'
import Vuex from 'vuex'

import Messages from '@/helpers/message-helper'

import { AuthState } from '@aws-amplify/ui-components'
import CognitoHelper from '@/helpers/cognito-helper'

import bus from '@/eventbus'

Vue.use(Vuex)


const state = {
	user: {},
	tokens: {}
}

const getters = {
	isAuthenticated: ({ user, tokens }) => user.hasOwnProperty('attributes') && tokens.hasOwnProperty('accessToken'),

	isAdmin: ({}, getters) => getters.isAuthenticated && getters.userRoles.includes('Administrators'),

	username: (state) => state.user.username,

	userRoles: (state, getters) => {
		if(!getters.isAuthenticated) return []
		const { signInUserSession: { accessToken: { payload } } } = state.user
		return payload["cognito:groups"] || []
	}
}

const mutations = {
	SET_USER(state, payload) {
		state.user = { ...payload }
	},

	SET_TOKENS(state, payload) {
		state.tokens = payload
	},

	CLEAR_USER(state) {
		state.user = {}
	}
}


const actions = {
	// Run on page load
	async init({ commit }) {
		const session = await CognitoHelper.getCognitoSession()
		console.info("Retrieved cognito session", session)
		if (!session) return

		commit('SET_TOKENS', session)

		const user = await CognitoHelper.getCognitoUser()
		commit('SET_USER', user)
	},

	// Event handler for Amplify login  dialog
	handleAuthChange({ commit }, { authState, authData }) {
		if (authState != AuthState.SignedIn) return

		commit('SET_USER', authData)
		commit('SET_TOKENS', authData.signInUserSession)

		bus.$emit('auth-close')
	},

	async signOut({ commit }) {
		try {
			commit('CLEAR_USER')
			await CognitoHelper.signOut()
		} catch (error) {
			Messages.showError(error)
		}
	},

	// Used by API to retrieve auth bearer token
	async getSession({ dispatch }) {
		try {
			return await CognitoHelper.getCognitoSession()
		} catch (error) {
			console.warning('User session not found. Deauthenticating.')
			dispatch('signOut')
		}
	}
}

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations
})
